<!--


Props:
    edit: caso seja verdadeiro, irá ser para editar integrante/parceiro.
    Caso seja falso, será para adicionar.
    idModal: define o id do modal.
    partner: se for verdadeiro, será para adicionar/editar parceiro.
    Se for falso, será para integrante.
    idEdit: o id do dado caso for editar
    funcaoRefresh: funcao de atualizar a página

    Para chamar o modal:  
    <button v-b-modal.oii></button>

   Modal adicionar integrantes:
    <ModalMembers idModal="oii" :funcaoRefresh="refreshPage"/>
    Modal editar integrantes:
    <ModalMembers edit idEdit="id do Dado para editar" idModal="oii" :funcaoRefresh="refreshPage"/>
    Modal adicionar parceiros:
    <ModalMembers partner idModal="oii" :funcaoRefresh="refreshPage"/>
    Modal editar parceiros:
    <ModalMembers partner edit idEdit="id do Dado para editar" idModal="oii" :funcaoRefresh="refreshPage"/>

    Obs: para evitar erro, coloque um id para cada modal.
    Está redirecionando para a home da dashboard, precisa mudar isso de acordo com a tabela
-->

<template>
  <div class="modal-class">
    <b-modal
      :id="idModal"
      ref="modal"
      no-footer
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      @hidden="resetModal"
      @show="editModal"
    >
      <div class="image-container">
        <img
          class="image"
          width="250px"
          v-bind:src="imageMainModal"
          alt="imagem do crop"
        />
      </div>
      <template #modal-header>
        <h5>{{ title }}</h5>
      </template>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Nome:"
          label-for="name-input"
          invalid-feedback="Digite o nome"
          :state="nameState"
        >
          <b-form-input
            id="name-input"
            v-model="form.name"
            :state="nameState"
            required
          ></b-form-input>
        </b-form-group>
      </form>
      <form ref="form2" @submit.stop.prevent="handleSubmit">
        <b-form-group id="input-group-2">
          <form>
            <label for="imageInput" class="custom-image-upload">
              <b-form-file
                id="imageInput"
                class="imageBootstrap"
                v-model="form.image"
                :state="imageState"
                @input="crop()"
                accept="image/*"
              ></b-form-file>
              {{ edit ? 'Editar arquivo' : 'Escolher arquivo' }}
            </label>
            {{ nameImage }}
          </form>

          <b-form-invalid-feedback :state="imageState">
            Insira uma imagem.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-modal
          id="modal-prevent-cropper"
          ref="modal"
          centered
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
        >
          <template #modal-header>
            <h5>Cortar Imagem</h5>
          </template>

          <cropper
            stencil-component="circle-stencil"
            ref="cropper"
            class="cropper"
            :src="urlImage"
            :stencil-props="{
              aspectRatio: 1,
              previewClass: 'preview-cropper-modal',
            }"
          />
          <b-container class="alignButton">
            <b-row>
              <b-col>
                <b-button
                  size="sm"
                  @click="cancelCropper()"
                  class="buttonFooter cancel mt-4 "
                >
                  Cancelar
                </b-button>
                <b-button
                  size="sm"
                  @click="okCropper()"
                  class="buttonFooter save mt-4 ml-2"
                >
                  Salvar
                </b-button>
              </b-col></b-row
            ></b-container
          >
        </b-modal>
      </form>
      <b-container class="alignButton">
        <b-row>
          <b-col>
            <b-button size="sm" v-b-modal.cancelar class="buttonFooter cancel mt-4 ">
              Cancelar
            </b-button>
            <b-button
              v-if="edit"
              size="sm"
              v-b-modal.editar
              class="buttonFooter save  mt-4 ml-2"
            >
              Salvar
            </b-button>
            <b-button v-else size="sm" @click="ok()" class="buttonFooter save  mt-4 ml-2">
              Salvar
            </b-button>
          </b-col></b-row
        ></b-container
      >
      <PopupConfirmacao
        id_modal="cancelar"
        cor_imagem="#E2574C"
        titulo="Atenção"
        texto="As alterações não serão salvas, deseja continuar?"
        texto_botao1="Continuar"
        cor_botao1="#FFFFFF"
        cor_background_botao1="#EB5353"
        hover_botao1="#a53a36"
        texto_botao2="Cancelar"
        cor_botao2="#FFFFFF"
        cor_background_botao2="#ADADAD"
        hover_botao2="#8b8b8b"
        :confirma_acao="cancel"
      />

      <PopupConfirmacao
        v-if="!partner"
        id_modal="editar"
        cor_imagem="#E2574C"
        titulo="Atenção"
        texto="Deseja editar esse integrante?"
        texto_botao1="Continuar"
        cor_botao1="#FFFFFF"
        cor_background_botao1="#28a745"
        hover_botao1="#28a745"
        texto_botao2="Cancelar"
        cor_botao2="#FFFFFF"
        cor_background_botao2="#ADADAD"
        hover_botao2="#8b8b8b"
        :confirma_acao="ok"
      />

      <PopupConfirmacao
        v-else
        id_modal="editar"
        cor_imagem="#E2574C"
        titulo="Atenção"
        texto="Deseja editar esse parceiro?"
        texto_botao1="Continuar"
        cor_botao1="#FFFFFF"
        cor_background_botao1="#28a745"
        hover_botao1="#28a745"
        texto_botao2="Cancelar"
        cor_botao2="#FFFFFF"
        cor_background_botao2="#ADADAD"
        hover_botao2="#8b8b8b"
        :confirma_acao="ok"
      />
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.image-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.image {
  border-radius: 150px;
}
.cropper {
  height: 25rem;
  background: #ddd;
  max-width: 765px;
  max-height: 474px;
  align-self: start;
}
#modal-prevent-closing {
  font-family: 'Noto Sans', sans-serif;
  .cropper {
    max-height: 60vh;
    width: 100%;
  }
}

.alignButton {
  text-align: right;
  margin-right: -1rem;
}
.buttonFooter {
  border: 1px solid;
  box-sizing: border-box;
  border-radius: 3px;
  width: 7rem;
  height: 2.3rem;
  font-size: 1rem;
}
.cancel {
  background-color: #cccccc;
  border: #cccccc;
  color: #ffffff;
}
.cancel:hover {
  background-color: #f04848;
  border: #f04848;
  color: #e9e9e9;
}
.save {
  background-color: #343842;
  border: #343842;
  color: #ffffff;
}
.escolherImagem {
  border: 1px #cccccc solid;
  border-radius: 3px;
  background-color: transparent;
  width: 13rem;
  height: 2.3rem;
  padding-right: 4rem;
}

.imageBootstrap {
  display: none;
}

.custom-image-upload {
  border: 1px solid #ccc;
  padding: 8px 20px 8px 20px;
  background: #fff;
  border-radius: 5px;
  color: #373a3c;
  font-weight: 400;
  cursor: pointer;
}
.custom-image-upload:hover {
  background: #ccc;
  transition: 0.3s;
}

@media (max-width: 280px) {
  .buttonFooter {
    width: 5rem;
    height: 2rem;
  }
}
</style>
<style>
.preview-cropper-modal {
  border: dashed 3px rgba(255, 255, 255, 100);
}
.vue-advanced-cropper__foreground {
  background-image: url('../../assets/cropper-bg.png');
}
</style>
<script>
import backUrl from '../../utils/backUrl';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import { postMembers, putMembers, getMembersIndividual } from '@/services/api/Members';
import { postPartners, putPartners, getPartnersIndividual } from '@/services/api/Partner';
import PopupConfirmacao from '@/components/dashboard/PopupConfirmacao.vue';
export default {
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    idModal: {
      type: String,
      required: true,
    },
    partner: {
      type: Boolean,
      default: false,
    },
    idEdit: {
      type: String,
      required: false,
    },
    funcaoRefresh: {
      type: Function,
      required: true,
    },
  },
  components: { Cropper, PopupConfirmacao },

  data() {
    return {
      form: {
        image: null,
        name: '',
        id: '',
      },

      title: '',
      imageMainModal: null,
      imageChanged: false,
      urlImage: '',
      nameImage: '',
      imageState: null,
      nameState: null,
    };
  },
  methods: {
    checkFormName() {
      const valid = this.form.name != '';

      this.nameState = valid;
      return valid;
    },
    checkFormImage() {
      if (!this.edit) {
        const valid = this.form.image != null && this.imageChanged;

        this.imageState = valid;
        return valid;
      } else {
        const valid = true;
        this.imageState = valid;
        return valid;
      }
    },
    editModal() {
      if (this.edit) {
        if (!this.idEdit) {
          this.$bvToast.toast('Não existe ID para edição', {
            title: 'Erro no ID',
            autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
            variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
          });
          this.$root.$emit('bv::hide::modal', this.idModal);
          if (!this.partner) {
            this.$router.push({ name: 'Team' });
          }
          if (this.partner) {
            this.$router.push({ name: 'Parcerias' });
          }
        } else {
          this.form.id = this.idEdit;

          if (this.partner) {
            getPartnersIndividual(this.form.id)
              .then((res) => {
                this.form.name = res.data.name;

                this.imageMainModal = `${backUrl}/download-file/images/${res.data.logo}`;
              })
              .catch(() => {
                this.$bvToast.toast(
                  'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
                  {
                    title: 'Erro interno no servidor',
                    autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                    variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
                  },
                );
              });
          } else {
            getMembersIndividual(this.form.id)
              .then((res) => {
                this.form.name = res.data.name;
                this.imageMainModal = `${backUrl}/download-file/images/${res.data.picture}`;
                //this.nameImage = res.data.picture;
              })
              .catch(() => {
                if (!this.partner) {
                  this.$router.push({ name: 'Team' });
                }
                if (this.partner) {
                  this.$router.push({ name: 'Parcerias' });
                }

                this.$bvToast.toast(
                  'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
                  {
                    title: 'Erro interno no servidor',
                    autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                    variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
                  },
                );
              });
          }
        }
      }
    },
    ok() {
      this.$root.$emit('bv::hide::modal', 'editar');
      if (this.checkFormName() && this.checkFormImage()) {
        let data = new FormData();

        data.append('name', this.form.name);

        if (this.edit) {
          if (this.partner) {
            if (this.form.image != null && this.imageChanged) {
              data.append('logo', this.form.image);
            }
            putPartners(data, this.form.id)
              .then(() => {
                this.$root.$emit('bv::hide::modal', this.idModal);
                this.resetModal();
                this.funcaoRefresh();
              })
              .catch(() => {
                this.$bvToast.toast(
                  'Erro ao editar parceiro, recarregue a página e tente novamente. Caso persista, tente novamente mais tarde.',
                  {
                    title: 'Erro ao editar parceiro',
                    autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                    variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
                  },
                );
              });
          } else {
            if (this.form.image != null && this.imageChanged) {
              data.append('picture', this.form.image);
            }

            putMembers(data, this.form.id)
              .then(() => {
                this.$root.$emit('bv::hide::modal', this.idModal);
                this.resetModal();
                this.funcaoRefresh();
              })
              .catch(() => {
                this.$bvToast.toast(
                  'Erro ao editar membro, recarregue a página e tente novamente. Caso persista, tente novamente mais tarde.',
                  {
                    title: 'Erro ao editar membro',
                    autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                    variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
                  },
                );
              });
          }
        } else {
          if (this.partner) {
            if (this.form.image != null && this.imageChanged) {
              data.append('logo', this.form.image);
            }
            postPartners(data)
              .then(() => {
                this.$root.$emit('bv::hide::modal', this.idModal);
                this.resetModal();

                this.funcaoRefresh();
              })
              .catch(() => {
                this.$bvToast.toast(
                  'Erro ao adicionar parceiro, recarregue a página e tente novamente. Caso persista, tente novamente mais tarde.',
                  {
                    title: 'Erro ao adicionar parceiro',
                    autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                    variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
                  },
                );
              });
          } else {
            data.append('picture', this.form.image);
            postMembers(data)
              .then(() => {
                this.$root.$emit('bv::hide::modal', this.idModal);
                this.resetModal();
                this.funcaoRefresh();
              })
              .catch(() => {
                this.$bvToast.toast(
                  'Erro ao adicionar membro, recarregue a página e tente novamente. Caso persista, tente novamente mais tarde.',
                  {
                    title: 'Erro ao adicionar membro',
                    autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                    variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
                  },
                );
              });
          }
        }
      }
    },
    cancel() {
      this.$root.$emit('bv::hide::modal', 'cancelar');
      this.$root.$emit('bv::hide::modal', this.idModal);

      this.resetModal();
    },
    resetModal() {
      this.form.name = '';
      this.nameState = null;
      this.form.image = null;
      this.imageMainModal = null;
      this.imageChanged = false;
      this.imageState = null;
      this.urlImage = '';
      this.nameImage = '';
    },

    crop() {
      if (this.form.image != null) {
        const readImage = () => {
          if (this.form.image) {
            var file = new FileReader();
            file.onload = (e) => {
              this.urlImage = e.target.result;
              setTimeout(() => {
                this.$root.$emit('bv::show::modal', 'modal-prevent-cropper');
              }, 100);
            };
            file.readAsDataURL(this.form.image);
          }
        };
        readImage();
      }
    },
    okCropper() {
      this.nameImage = this.form.image.name;
      this.imageChanged = true;

      this.$root.$emit('bv::hide::modal', 'modal-prevent-cropper');

      this.form.image = this.$refs.cropper.getResult().canvas;

      this.imageMainModal = this.$refs.cropper.getResult().canvas.toDataURL();

      this.form.image.toBlob(
        (blob) => {
          this.form.image = blob;

          this.$root.$emit('bv::show::modal', this.idModal);
          this.form.image = new File([this.form.image], 'img.png', {
            lastModified: new Date().getTime(),
            type: this.form.image.type,
          });
        },
        'image/png',
        0.75,
      );
    },
    cancelCropper() {
      this.$root.$emit('bv::hide::modal', 'modal-prevent-cropper');
    },
  },
  mounted() {
    if (this.edit) {
      if (this.partner) this.title = 'Editar Parceiro';
      else this.title = 'Editar Integrante';
    } else {
      if (this.partner) this.title = 'Adicionar Parceiro';
      else this.title = 'Adicionar Integrante';
    }
  },
};
</script>
